var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52796 0.467309C1.23376 0.175726 0.758893 0.177844 0.467309 0.472041C0.175726 0.766238 0.177844 1.24111 0.472041 1.53269L2.23501 3.28C2.9505 3.98914 3.44131 4.47718 3.77341 4.89071C4.096 5.2924 4.20668 5.55042 4.23613 5.7815C4.25462 5.92659 4.25462 6.07341 4.23613 6.2185C4.20668 6.44958 4.096 6.7076 3.77341 7.10929C3.44131 7.52282 2.9505 8.01086 2.23501 8.72L0.472041 10.4673C0.177844 10.7589 0.175726 11.2338 0.467309 11.528C0.758893 11.8222 1.23376 11.8243 1.52796 11.5327L3.32269 9.7539C3.99866 9.08396 4.55114 8.53641 4.94294 8.04854C5.35037 7.54122 5.64531 7.02628 5.72409 6.40816C5.75864 6.13714 5.75864 5.86286 5.72409 5.59184C5.64531 4.97372 5.35037 4.45878 4.94294 3.95146C4.55114 3.46359 3.99866 2.91604 3.32269 2.24609L1.52796 0.467309Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1173_699",
    x1: 1.28794,
    y1: -2.96324,
    x2: 6.31912,
    y2: -2.68278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "fill"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e704fec8689529a654b2fdc0f7f99751.svg";
export { ForwardRef as ReactComponent };